import React from "react";
import { Modal, Image } from "react-bootstrap";

const DeleteModal = ({ onDelete, show, handleModalOpen }) => {

  const handleClose = () => { 
    handleModalOpen(false);
  };

  return (
    <Modal show={show} centered onHide={handleClose}>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <Image src="/assets/images/Delete-main.svg" alt="Delete Icon" />
        </div>
        <p className="font-14 font-weight-medium mb-4">
          Are you sure you want to delete this?
        </p>
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button className="delete-btn" onClick={onDelete}>
            Delete
          </button>
          <button className="c-b-btn" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;